/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_Cta_PrimaryInputs */

const en_home_hero_cta_primary = /** @type {(inputs: Home_Hero_Cta_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open JSON Viewer`)
};

const ko_home_hero_cta_primary = /** @type {(inputs: Home_Hero_Cta_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 뷰어 열기`)
};

const ja_home_hero_cta_primary = /** @type {(inputs: Home_Hero_Cta_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON ビューアを開く`)
};

/**
* | output |
* | --- |
* | "Open JSON Viewer" |
*
* @param {Home_Hero_Cta_PrimaryInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const home_hero_cta_primary = /** @type {((inputs?: Home_Hero_Cta_PrimaryInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_Cta_PrimaryInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_hero_cta_primary(inputs)
	if (locale === "ko") return ko_home_hero_cta_primary(inputs)
	return ja_home_hero_cta_primary(inputs)
});